// @core/api/endpoints/notifications/cancel_notification_scheduled.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/notifications';

/**
 * Cancel scheduled notification
 * Cancels a previously scheduled notification before it is sent. The notification will be removed from the queue and will not be delivered.
 */
export async function CancelNotificationScheduled(
  schedule_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/notifications/scheduled/:schedule_id`;
  requestPath = requestPath.replace(':schedule_id', encodeURIComponent(schedule_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
